<template>
	<div class="container">
		<div class="row justify-center">
			<div class="col-md-8">
				<div class="panel">
					<div class="panel-title">
						<div class="panel-heading">Login With Code</div>
					</div>
					<div class="panel-body">
						<ui-notice v-if="error" type="warning" icon="fas fa-exclamation-circle" :msg="error"/>

						<ui-form ref="form" @submit.prevent="submit">
							<ui-text-box-field
								v-model="info.code"
								:rules="rules.code"
								label="Login Code"
								prepend-icon="fas fa-user"
								autofocus>
							</ui-text-box-field>

							<ui-text-box-field
								v-if="showPassword"
								v-model="info.password"
								:rules="rules.password"
								password
								label="Password"
								prepend-icon="fas fa-lock">
							</ui-text-box-field>
						</ui-form>
					</div>
					<div class="panel-footer">
						<ui-button color="primary" @click="submit" :loading="loading">Submit</ui-button>
						<span class="flex-spacer"></span>
						<ui-button color="text" href="/admin/recovery/forgot_password">Forgot Password?</ui-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { createApi } from 'igolf/shared/api';

const api = createApi('/admin');

export default {
	data()
	{
		return {
			error: false,
			loading: false,
			showPassword: false,

			info: {
				code: '',
				password: '',
			},

			rules: {
				code: [ v => !!v || 'Please enter your username' ],
				password: [ v=> !this.showPassword || !!v || 'Please enter your password' ],
			}
		}
	},

	methods: {
		async submit()
		{
			if (!this.$refs.form.validate())
				return;

			this.loading = true;
			this.error = false;

			try
			{
				var params = {}, result;

				// send login code with request
				params.login_code = this.info.code;

				// if required send password
				if (this.showPassword)
					params.password = this.info.password;

				// try to authenticate
				result = await api.post('/authenticate_with_code', params);

				// check for success
				if (result.data.success)
				{
					document.location = '/admin';
				}
				// otherwise report error
				else
				{
					if (result.data.reason == 'invalid_code')
					{
						this.error = 'Invalid login code';
					}
					else if (result.data.reason == 'invalid_login')
					{
						this.error = 'Invalid password';
					}
					else if  (result.data.reason == 'requires_password')
					{
						this.error = 'You must enter your password';
						this.showPassword = true;
					}
				}
			}
			finally
			{
				this.loading = false;
			}
		}
	},
}
</script>